import React from "react";
import { FiChevronRight } from "react-icons/fi";

const SkillsKey = ({ skillKeys, selectedKey, onSelect, skills }) => {
  return (
    <div className="p-4">
      {skillKeys.map((key) => (
        <div
          key={key}
          className={`cursor-pointer p-2 mb-2 rounded flex items-center ${
            selectedKey === key
              ? "active-skill"
              : "bg-white text-black hover:bg-gray-200"
          }`}
          
        //   className={`cursor-pointer p-2 mb-2 rounded ${
        //     selectedKey === key
        //       ? "bg-blue-500 text-white"
        //       : "bg-white text-black hover:bg-gray-200"
        //   }`}
          onClick={() => onSelect(key)}
        >
             <span className="mr-3 text-xl">{skills[key].icon}</span>
             {/* <span className="capitalize font-medium">{key}</span> */}
          {key.charAt(0).toUpperCase() + key.slice(1)}
          {/* <span className="ml-auto transition-transform duration-200 ease-in-out">
            {selectedKey === key ? "⌄" : "›"}
          </span> */}
          <FiChevronRight
            className={`ml-auto text-xl transform transition-transform duration-300 ease-in-out ${
              selectedKey === key ? "rotate-90" : ""
            }`}
          />

        </div>
      ))}
    </div>
  );
};

export default SkillsKey;
